export const LANGUAGES = [
  { label: "Português", code: "pt" },
  { label: "English", code: "en" },
];
